export class RuejaiClubGroupCategoryClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/categories/group`;
  }

  async list() {
    const url = this.baseURL;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async categorylist(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}